import { IconProps } from "../../utils/global-types/global-types";

const FilterV2Icon = ({ className, ...rest }: IconProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
      className={className ? className : "w-6 h-6"}
      {...rest}
    >
      <path
        d="M1 5C1 4.55817 1.35817 4.2 1.8 4.2H16.2C16.6418 4.2 17 4.55817 17 5C17 5.44182 16.6418 5.8 16.2 5.8H1.8C1.35817 5.8 1 5.44182 1 5Z"
        fill="currentColor"
      />
      <path
        d="M3.40002 9C3.40002 8.55817 3.7582 8.2 4.20002 8.2H13.8C14.2419 8.2 14.6 8.55817 14.6 9C14.6 9.44184 14.2419 9.8 13.8 9.8H4.20002C3.7582 9.8 3.40002 9.44184 3.40002 9Z"
        fill="currentColor"
      />
      <path
        d="M7.39998 12.2C6.95815 12.2 6.59998 12.5582 6.59998 13C6.59998 13.4418 6.95815 13.8 7.39998 13.8H10.6C11.0418 13.8 11.4 13.4418 11.4 13C11.4 12.5582 11.0418 12.2 10.6 12.2H7.39998Z"
        fill="currentColor"
      />
    </svg>
  );
};

export default FilterV2Icon;
